import React from 'react';
import { BDS_TEAM_LEAD_TITLE, isRizeForRealtorFlow } from '../../../../config/flows';

const ManagerInfo = ({ data, setIsManagerModalOpen, flowType }) => (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
        <div className="flex items-center justify-between gap-4">
            <div>
                <h2 className="text-base font-bold text-[#0a1445] sm:text-lg">
                    {isRizeForRealtorFlow(flowType) ? `${BDS_TEAM_LEAD_TITLE} Comp Info` : 'Manager Comp Info'}
                    <span className="text-red-600"> *</span>
                </h2>
            </div>
            <div>
                {Object.keys(data?.manager).length === 0 && (<button 
                    onClick={() => setIsManagerModalOpen(true)}
                    className="inline-flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-[#211b4f] text-white transition-colors hover:bg-[#30266c]"
                    type="button"
                    aria-label="Add Manager Comp Info"
                >
                    <svg className="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 12h14m-7 7V5"/>
                    </svg>
                </button>)}
            </div>
        </div>

        {Object.keys(data?.manager).length > 1 && (
            <div className="mt-4 grid grid-cols-8 items-center justify-between gap-2 rounded-xl border border-slate-200 bg-[#f7f2ef] p-4">
                <p className="col-span-2 truncate text-sm font-semibold text-[#211b4f]">{data.manager.firstName} {data.manager.lastName}</p>
                <p className="col-span-3 text-md text-gray-500 truncate">{data.manager.email}</p>
                <p className="col-span-2 text-md text-gray-500 truncate">{data.manager.title}</p>
                <button
                    type='button'
                    onClick={() => setIsManagerModalOpen(true)}
                    className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-[#211b4f] hover:bg-white"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                    </svg>
                </button>
            </div>
        )}
    </section>
);

export default ManagerInfo;
